var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6331 13.6332H11.2622V9.92038C11.2622 9.03495 11.2464 7.89564 10.0291 7.89564C8.79436 7.89564 8.60513 8.85991 8.60513 9.85651V13.6332H6.23506V5.99784H8.51131V7.04096H8.54285C9.00724 6.24778 9.86981 5.77392 10.7884 5.80782C13.1915 5.80782 13.6339 7.38867 13.6339 9.44415L13.6331 13.6332ZM3.55985 4.95393C2.79978 4.95393 2.184 4.33816 2.184 3.57809C2.184 2.81803 2.79978 2.20225 3.55985 2.20225C4.31991 2.20225 4.93569 2.81803 4.93569 3.57809C4.93569 4.33816 4.31991 4.95393 3.55985 4.95393ZM4.74489 13.6332H2.37166V5.99784H4.74489V13.6332ZM14.815 0.000896145H1.18031C0.536146 -0.0061999 0.00788449 0.510234 0 1.1544V14.845C0.00788449 15.49 0.536146 16.0064 1.18031 15.9993H14.815C15.4607 16.0072 15.9913 15.4908 16 14.845V1.15361C15.9905 0.507869 15.4599 -0.00856528 14.815 0.000107659",
    fill: "#40495D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f1ed2517417206929f4a57bb1b5732cb.svg";
export { ForwardRef as ReactComponent };